import Hammer from "hammerjs";

const directionMaps = ["", "", "left", "", "right"];

export default {
  install: function (Vue) {
    Vue.directive("hammer", {
      bind: function (dom, options) {
        // console.log("----bind----", arguments);
        const hammerInstance = new Hammer(dom, {});
        hammerInstance.on(options.arg, function (event) {
          event.directionCn = directionMaps[event.direction];
          options.value(event);
        });
      },
      inserted: function () {
        // console.log("----inserted----", arguments);
      },
      update: function () {
        // console.log("----update----", arguments);
      },
      componentUpdated: function () {
        // console.log("----componentUpdated----", arguments);
      },
      unbind: function () {
        // console.log("----unbind----", arguments);
      },
    });
  },
};
